/* eslint-disable import/prefer-default-export */
import { add } from 'helpers/QueryHelper';
import _ from 'lodash';
import { SumStringToArray } from './Result';

const typesResult = {
  writeResult: '',
  oneChoiceResult: '',
  multipleChoiceResult: '',
  matchResult: '',
  selectWordResult: '',
  dropDownResult: '',
  dragDropResult: '',
};

export const saveToServer = async (file, score, data, studentId, studentData) => {
  const { result, resultListen } = data;
  const isEmpty = JSON.stringify(result) === '{}';

  for (const temp in result) {
    typesResult[temp] = result[temp].resultString;
  }

  // _.forIn(result, (value, key) => {
  //   typesResult[key] = value[key].resultString;
  // });

  // Object.assign(typesResult, result);

  const resultData = isEmpty ? resultListen : result;
  //
  const resultArray = SumStringToArray(resultData, 'resultString');
  const [completed, totalCompleted] = SumStringToArray(resultData, 'complete');

  const newScore = isEmpty ? (completed * 10) / totalCompleted : score;

  return add(
    'Assignments_Answers',
    {
      ...studentData,
      StudentId: studentId,
      AttachmentId: file.id,
      JsonData: JSON.stringify(data),
      Type: 'LIVEWORKSHEET',
      Score: Math.round(newScore * 10),
      TeacherNoteS: '',
      Notes: '',
      Star: Math.floor(newScore * 10),
      completedPercent: Math.round((completed / totalCompleted[1]) * 100),
      TotalQuestion: totalCompleted,
      TotalAnswer: completed,
      PassedQuestion: resultArray[0],
      ...typesResult,
    },
    'CLASSWORK',
  );
};
